import * as fromDatatype from "../datatype-library/index";

export interface bl_wms_container_line_RowInterface {
    guid : fromDatatype.GuidDataFieldInterface;
    hdr_guid : fromDatatype.GuidDataFieldInterface;
    wms_item_guid : fromDatatype.GuidDataFieldInterface;
    fi_item_guid : fromDatatype.GuidDataFieldInterface;
    inv_item_guid : fromDatatype.GuidDataFieldInterface;
    qty_base : fromDatatype.NumericDatatypeInterface;
    uom : fromDatatype.VarcharDatatypeInterface;
    qty_uom : fromDatatype.NumericDatatypeInterface;
    created_date : fromDatatype.TimestampTzDatatypeInterface;
    updated_date : fromDatatype.TimestampTzDatatypeInterface;
    created_by_subject_guid : fromDatatype.GuidDataFieldInterface;
    updated_by_subject_guid : fromDatatype.GuidDataFieldInterface;
    status : fromDatatype.VarcharDatatypeInterface;
    revision: fromDatatype.GuidDataFieldInterface;
    vrsn : fromDatatype.VarcharDatatypeInterface;
    module_guid : fromDatatype.GuidDataFieldInterface;
    applet_guid : fromDatatype.GuidDataFieldInterface;
    property_json: fromDatatype.JsonDatatypeInterface;
    acl_policy: fromDatatype.JsonDatatypeInterface;
    acl_config: fromDatatype.JsonDatatypeInterface;
    split_qty: fromDatatype.NumericDatatypeInterface;
}

export class bl_wms_container_line_RowClass implements bl_wms_container_line_RowInterface {
    guid : fromDatatype.GuidDataFieldInterface;
    hdr_guid : fromDatatype.GuidDataFieldInterface;
    wms_item_guid : fromDatatype.GuidDataFieldInterface;
    fi_item_guid : fromDatatype.GuidDataFieldInterface;
    inv_item_guid : fromDatatype.GuidDataFieldInterface;
    qty_base : fromDatatype.NumericDatatypeInterface;
    uom : fromDatatype.VarcharDatatypeInterface;
    qty_uom : fromDatatype.NumericDatatypeInterface;
    created_date : fromDatatype.TimestampTzDatatypeInterface;
    updated_date : fromDatatype.TimestampTzDatatypeInterface;
    created_by_subject_guid : fromDatatype.GuidDataFieldInterface;
    updated_by_subject_guid : fromDatatype.GuidDataFieldInterface;
    status : fromDatatype.VarcharDatatypeInterface;
    revision: fromDatatype.GuidDataFieldInterface;
    vrsn : fromDatatype.VarcharDatatypeInterface;
    module_guid : fromDatatype.GuidDataFieldInterface;
    applet_guid : fromDatatype.GuidDataFieldInterface;
    property_json: fromDatatype.JsonDatatypeInterface;
    acl_policy: fromDatatype.JsonDatatypeInterface;
    acl_config: fromDatatype.JsonDatatypeInterface;
    split_qty: fromDatatype.NumericDatatypeInterface;
}